/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeKind } from './ChangeKind';
import {
    ChangeKindFromJSON,
    ChangeKindFromJSONTyped,
    ChangeKindToJSON,
    ChangeKindToJSONTyped,
} from './ChangeKind';

/**
 * 
 * @export
 * @interface AnnexRowChangeDto
 */
export interface AnnexRowChangeDto {
    /**
     * 
     * @type {string}
     * @memberof AnnexRowChangeDto
     */
    row: string;
    /**
     * 
     * @type {ChangeKind}
     * @memberof AnnexRowChangeDto
     */
    kind: ChangeKind;
    /**
     * 
     * @type {string}
     * @memberof AnnexRowChangeDto
     */
    previousValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnnexRowChangeDto
     */
    currentValue?: string | null;
}



/**
 * Check if a given object implements the AnnexRowChangeDto interface.
 */
export function instanceOfAnnexRowChangeDto(value: object): value is AnnexRowChangeDto {
    if (!('row' in value) || value['row'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function AnnexRowChangeDtoFromJSON(json: any): AnnexRowChangeDto {
    return AnnexRowChangeDtoFromJSONTyped(json, false);
}

export function AnnexRowChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnexRowChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'row': json['row'],
        'kind': ChangeKindFromJSON(json['kind']),
        'previousValue': json['previousValue'] == null ? undefined : json['previousValue'],
        'currentValue': json['currentValue'] == null ? undefined : json['currentValue'],
    };
}

export function AnnexRowChangeDtoToJSON(json: any): AnnexRowChangeDto {
    return AnnexRowChangeDtoToJSONTyped(json, false);
}

export function AnnexRowChangeDtoToJSONTyped(value?: AnnexRowChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'row': value['row'],
        'kind': ChangeKindToJSON(value['kind']),
        'previousValue': value['previousValue'],
        'currentValue': value['currentValue'],
    };
}

